/*global Sentry*/ //https://github.com/octalmage/gatsby-plugin-sentry/issues/20
import React from "react"

export const ACTION_STATUSES = {
	SENDING: "SENDING",
	NOT_SEND: "NOT_SEND",
	SUCCESS: "SUCCESS",
	FAIL: "FAIL",
}

// Абстрактный компонент без `render()`, который имеет общие методы и `state`
// Компонент экстендится конечными CTA формами. Каждая такая форма должна имплементировать
// методы `validateInput` и `actionRequest`, которые вызываются в `actionButtonHandler`.
export default class CtaAbstractSection extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			inputValue: "",
			inputInvalidMessage: "",
			actionStatus: ACTION_STATUSES.NOT_SEND,
			agreementStatus: true,
			agreementWarning: false,
		}
	}

	hideNotification = () => {
		this.setState({
			actionStatus: ACTION_STATUSES.NOT_SEND,
		})
	}

	inputChangeHandler = value => {
		this.setState({
			inputValue: value,
		})
	}

	// formType нужен чтобы различать тип формы ("phone" или "email");
	// в данном случае нужен для Sentry.
	//TODO может как-то различать по функции-валидатору, т.к. она разная для phone и email
	actionButtonHandler = async formType => {
		// Ставим статус 'SENDING' во время которого контроллер будет заблокирован (или показываться спиннер):
		this.setState({ actionStatus: ACTION_STATUSES.SENDING })

		try {
			const inputValidState = await this.validateInput(this.state.inputValue)

			if (inputValidState.valid && this.state.agreementStatus) {
				await this.actionRequest(this.state.inputValue)

				this.setState({
					inputValue: "",
					inputInvalidMessage: "",
					actionStatus: ACTION_STATUSES.SUCCESS,
				})
			} else if (!this.state.agreementStatus) {
				this.setState({
					agreementWarning: true,
					actionStatus: ACTION_STATUSES.NOT_SEND,
				})
			} else {
				this.setState({
					inputInvalidMessage: inputValidState.message,
					actionStatus: ACTION_STATUSES.NOT_SEND,
				})
			}
		} catch (error) {
			Sentry.captureException(error, scope => scope.setTag("source", formType))

			// При возникновении ошибки на сервере, нужно отправить запрос в `amoCrm`
			// Метод для запроса определяется в конкретном классе
			this.ctaErrorAmoOffer()

			this.setState({
				inputValue: "",
				inputInvalidMessage: "",
				actionStatus: ACTION_STATUSES.FAIL,
			})
		}
	}
}
